// Components
import Button from "components/atoms/Button/Button";

// Constants
import { MONTHLY_DECLARATIONS } from "constants/global";

// Hooks
import { useMonthlyDeclarationButtons } from "containers/MonthlyDeclaration/useMonthlyDeclarationButtons";

// Type Definitions
import type { ReimbSummaryDataType } from "redux/types";

export type ButtonVariants = "ViewEdit" | "Declare" | "View" | "";

export type MonthlyDeclarationButtonsProps = {
	reimbSummaryItem: ReimbSummaryDataType;
	variant?: ButtonVariants;
};

const MonthlyDeclarationButtons = ({ variant, reimbSummaryItem }: MonthlyDeclarationButtonsProps) => {
	const { isSelectionAvailable, handleDeclare, handleAccept, handleReject, handleEdit, handleView } = useMonthlyDeclarationButtons({ reimbSummaryItem });

	return (
		<>
			{variant ? (
				<>
					{!isSelectionAvailable && variant === MONTHLY_DECLARATIONS.DECLARE_VARIANT && (
						<div className="flex justify-center">
							<Button {...MONTHLY_DECLARATIONS.BUTTON_LABELS.DECLARE} onClick={handleDeclare} />
						</div>
					)}
					{isSelectionAvailable && variant === MONTHLY_DECLARATIONS.DECLARE_VARIANT && (
						<div className="flex justify-center">
							<Button {...MONTHLY_DECLARATIONS.BUTTON_LABELS.ACCEPT} onClick={handleAccept} />
							<span className="mx-[5px]"></span>
							<Button {...MONTHLY_DECLARATIONS.BUTTON_LABELS.REJECT} onClick={handleReject} />
						</div>
					)}
					{!isSelectionAvailable && variant === MONTHLY_DECLARATIONS.VIEW_EDIT_VARIANT && (
						<div className="flex justify-center">
							<Button {...MONTHLY_DECLARATIONS.BUTTON_LABELS.VIEWEDIT} onClick={handleEdit} />
						</div>
					)}
					{!isSelectionAvailable && variant === MONTHLY_DECLARATIONS.VIEW_VARIANT && (
						<div className="flex justify-center">
							<Button {...MONTHLY_DECLARATIONS.BUTTON_LABELS.VIEW} onClick={handleView} />
						</div>
					)}
				</>
			) : (
				<></>
			)}
		</>
	);
};

export default MonthlyDeclarationButtons;
